export enum TransactionStatusEnum {
  Pending = 'Pending',
  InfoNeeded = 'Information Needed',
  Inactive = 'Inactive',
  Cancelled = 'Cancelled',
  Approved = 'Approved',
  Denied = 'Denied',
  Deleted = 'Deleted',
  Completed = 'Completed',
  Outstanding = 'Outstanding',
  Duplicate = 'Duplicate',
  Imported = 'Imported',
  Reversed = 'Reversed',
  Matched = 'Matched',
}
